import { render, staticRenderFns } from "./NewTax.vue?vue&type=template&id=e1f833bc"
import script from "./NewTax.vue?vue&type=script&lang=js"
export * from "./NewTax.vue?vue&type=script&lang=js"
import style0 from "./NewTax.vue?vue&type=style&index=0&id=e1f833bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports